<div class="select-with-action">
  <app-select
    class="select-with-action__select"
    [control]="control"
    [options]="options"
    [valueKey]="valueKey"
    [labelKey]="labelKey"
    [emptyLabel]="emptyLabel"
    [emptyValue]="emptyValue"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [isInvalid]="isInvalid"
    [inputId]="inputId"
    [testId]="testId"
    [panelClass]="panelClass"
    [greyWhenEmpty]="greyWhenEmpty"
    [greyValues]="greyValues"
    [helpText]="helpText"
    (selectionChange)="selectionChange.emit($event)"
  ></app-select>

  <app-button
    *ngIf="actionVisible"
    class="select-with-action__btn"
    variant="primary"
    [startIcon]="actionIcon"
    [disabled]="actionDisabled"
    (click)="action.emit()"
  >
    {{ actionLabel | translate }}
  </app-button>
</div>
